module.exports = __webpack_public_path__ + "static/media/Teknion-Logo-Grey.67580c46.png";